module.exports = __webpack_public_path__ + "static/logoMUfinal-307277fdd6e919f0aa6d2a126a9e21b7.png";